export interface ScrollVisibilityInput {
  currentY: number;
  previousY: number;
  scrollReferenceY: number;
  viewportHeight: number;
  isExtraLarge: boolean;
  isAtBottom: boolean;
  isVisible: boolean;
}

export const SCROLLED_UP_THRESHOLD = 16;

export function nextVisibility({
  currentY,
  previousY,
  scrollReferenceY,
  viewportHeight,
  isExtraLarge,
  isAtBottom,
  isVisible,
}: ScrollVisibilityInput): boolean {
  const scrolledDown = currentY > previousY;
  const scrolledUp = currentY < scrollReferenceY - SCROLLED_UP_THRESHOLD;

  if (currentY <= viewportHeight) return false;
  if (isExtraLarge) return scrolledDown || isVisible;
  if (scrolledDown) return false;
  if (isAtBottom || scrolledUp) return true;
  return isVisible;
}
